import axios from '@/utils/request';

const v1 = `easycard`;
export const getEasycards = ({ company_id = 1, size = 10, page = 1, status = 0 }) =>
  axios.get(`${v1}/sales`, {
    params: { company_id, page, size, status },
  });

export const getInvoiceAvalible = (data) => axios.post(`v1/admin/invoice/avalible`, data);
